"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontColourPropertyAndValue = exports.getPropertyAndValue = void 0;
var lodash_1 = require("lodash");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
function getPropertyAndValue(path, propertyType, style, properties) {
    var property = properties.find(function (p) { return p.path === path && p.type === propertyType; });
    var value = (0, lodash_1.get)(style, path);
    (0, tiny_invariant_1.default)(property != undefined, "There is no property with path ".concat(path));
    (0, tiny_invariant_1.default)(value != undefined, "Computed style at ".concat(path, " does not have a value"));
    return { property: property, value: value };
}
exports.getPropertyAndValue = getPropertyAndValue;
function getFontColourPropertyAndValue(style, properties) {
    var _a = getPropertyAndValue("color", "color", style, properties), property = _a.property, value = _a.value;
    (0, tiny_invariant_1.default)("abs" in value, "The font colour `value` should have been remarshalled to a `IColorObjectType` by `widgetStyle()`");
    return { property: property, value: value };
}
exports.getFontColourPropertyAndValue = getFontColourPropertyAndValue;
